import React from 'react'
import styled from 'styled-components'
import Form from './Form'
import DayPicker from './DayPicker'

const Container = styled.div`
  position: sticky;
  z-index: 1;
  top: 0px;
  background-color: white;
  display: flex;
  width: 100%;  
  height: 60px;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.5rem;
  box-shadow: 0px .5px 8px 0px rgba(0, 0, 0, 0.3);
`

// Header.js and Calendar.js are the direct children of App.js
export default function Header (props) {
  return (
    <Container>
      <DayPicker {...props}/>
      <Form setDb={props.setDb} today={props.today} showForm={props.showForm} setShowForm={props.setShowForm}/>
    </Container>
  )
}